const _excluded = ["svgRef", "title"];

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }

function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }

import React from "react";

var _ref2 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M4.5 31H4.45C4.25 31 4.1 30.8645 4 30.5936V16.4855L4.025 2.37738C4.19167 2.12579 4.35 2 4.5 2C4.71667 2 4.88333 2.14515 5 2.43544V30.5936C4.86667 30.8645 4.71667 31 4.55 31H4.5Z",
  fill: "#1E3F6B"
});

var _ref3 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M30.5 20H30.45C30.25 20 30.1 19.9159 30 19.7477V10.991L30.025 2.23423C30.1917 2.07808 30.35 2 30.5 2C30.7167 2 30.8833 2.09009 31 2.27027V19.7477C30.8667 19.9159 30.7167 20 30.55 20H30.5Z",
  fill: "#1E3F6B"
});

var _ref4 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M1.5 31H1.45C1.25 31 1.1 30.8645 1 30.5936V16.4855L1.025 2.37738C1.19167 2.12579 1.35 2 1.5 2C1.71667 2 1.88333 2.14515 2 2.43544V30.5936C1.86667 30.8645 1.71667 31 1.55 31H1.5Z",
  fill: "#1E3F6B"
});

var _ref5 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M27.5 20H27.45C27.25 20 27.1 19.9159 27 19.7477V10.991L27.025 2.23423C27.1917 2.07808 27.35 2 27.5 2C27.7167 2 27.8833 2.09009 28 2.27027V19.7477C27.8667 19.9159 27.7167 20 27.55 20H27.5Z",
  fill: "#1E3F6B"
});

var _ref6 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("rect", {
  x: -0.5,
  y: 0.5,
  width: 7,
  height: 9,
  transform: "matrix(1 0 0 -1 7 13)",
  stroke: "#0081CC"
});

var _ref7 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("rect", {
  x: -0.5,
  y: 0.5,
  width: 7,
  height: 9,
  transform: "matrix(1 0 0 -1 7 29)",
  stroke: "#0081CC"
});

var _ref8 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("rect", {
  x: -0.5,
  y: 0.5,
  width: 7,
  height: 9,
  transform: "matrix(1 0 0 -1 19 13)",
  stroke: "#0081CC"
});

var _ref9 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M20.7988 24.8256C20.7988 24.6272 20.8596 24.4544 20.9812 24.3072C21.1092 24.16 21.2692 24.0608 21.4612 24.0096C21.4868 24.0032 21.5284 24 21.586 24C21.9188 24 22.162 24.1312 22.3156 24.3936C22.3988 24.5216 22.4404 24.6656 22.4404 24.8256C22.4404 25.0048 22.386 25.168 22.2772 25.3152C22.1748 25.456 22.034 25.5552 21.8548 25.6128C21.7972 25.6256 21.7204 25.632 21.6244 25.632C21.4196 25.632 21.2436 25.5712 21.0964 25.4496C20.898 25.296 20.7988 25.088 20.7988 24.8256Z",
  fill: "#1E3F6B"
});

var _ref10 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M23.8645 24.8256C23.8645 24.6272 23.9253 24.4544 24.0469 24.3072C24.1749 24.16 24.3349 24.0608 24.5269 24.0096C24.5525 24.0032 24.5941 24 24.6517 24C24.9845 24 25.2277 24.1312 25.3813 24.3936C25.4645 24.5216 25.5061 24.6656 25.5061 24.8256C25.5061 25.0048 25.4517 25.168 25.3429 25.3152C25.2405 25.456 25.0997 25.5552 24.9205 25.6128C24.8629 25.6256 24.7861 25.632 24.6901 25.632C24.4853 25.632 24.3093 25.5712 24.1621 25.4496C23.9637 25.296 23.8645 25.088 23.8645 24.8256Z",
  fill: "#1E3F6B"
});

var _ref11 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M26.9301 24.8256C26.9301 24.6272 26.9909 24.4544 27.1125 24.3072C27.2405 24.16 27.4005 24.0608 27.5925 24.0096C27.6181 24.0032 27.6597 24 27.7173 24C28.0501 24 28.2933 24.1312 28.4469 24.3936C28.5301 24.5216 28.5717 24.6656 28.5717 24.8256C28.5717 25.0048 28.5173 25.168 28.4085 25.3152C28.3061 25.456 28.1653 25.5552 27.9861 25.6128C27.9285 25.6256 27.8517 25.632 27.7557 25.632C27.5509 25.632 27.3749 25.5712 27.2277 25.4496C27.0293 25.296 26.9301 25.088 26.9301 24.8256Z",
  fill: "#1E3F6B"
});

const SvgEquationMatrix6 = _ref => {
  let {
    svgRef,
    title
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef
  }, props), /*#__PURE__*/React.createElement("title", null, title), _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11);
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgEquationMatrix6, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/equation-matrix-6.d99dcc19.svg";
export { ForwardRef as ReactComponent };